module.exports = "#userForm {\n  padding: 15px 0;\n}\n#show-password {\n  width: 37px;\n  height: 37px;\n}\n#show-password i {\n  margin-right: 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/users/users.component.css
// module id = ./src/app/components/users/users.component.css
// module chunks = main